import React, { useEffect, useRef, useState } from 'react';

import { DataLoadingStatus } from 'common/components/RewindModal';
import { IMG_REWIND_2025 } from 'common/configuration/constants';

import styles from '../styles.module.scss';

type LoadingProps = {
  dataLoadingStatus?: DataLoadingStatus;
  onNext: () => void;
  steps: number;
  subtitle?: string;
  title?: string;
  trackingScreenName?: string;
};

const MINIMUM_DISPLAY_TIME = 2000;

const Loading = ({ dataLoadingStatus, onNext, steps, title }: LoadingProps) => {
  const [progress, setProgress] = useState(0);
  const mountTime = useRef(Date.now());

  useEffect(() => {
    if (dataLoadingStatus === 'loading') {
      const interval = setInterval(() => {
        setProgress(currentProgress => {
          if (currentProgress >= 90) {
            clearInterval(interval);
            return 90;
          }
          return currentProgress + 5;
        });
      }, 100);

      return () => clearInterval(interval);
    }
  }, [dataLoadingStatus]);

  useEffect(() => {
    if (dataLoadingStatus === 'loaded' && steps > 1) {
      const elapsedTime = Date.now() - mountTime.current;
      const remainingTime = Math.max(0, MINIMUM_DISPLAY_TIME - elapsedTime);

      const finalTimeout = setTimeout(() => {
        setProgress(100);
        setTimeout(onNext, 1000);
      }, remainingTime);

      return () => clearTimeout(finalTimeout);
    }
  }, [dataLoadingStatus, steps, onNext]);

  return (
    <div className={styles.loadingStep}>
      <img
        src={IMG_REWIND_2025}
        alt="Flashback"
        className={styles.flashbackLoadingLogo}
      />
      <div className={styles.titleLoading}>{title}</div>
      <div className={styles.progressBar}>
        <div className={styles.bar} style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
};

export default Loading;
